export const getCurrentUserUrl = () => '/business/profiles';

export const getUserStatusUrl = (userId: number | string) => `/agency/profiles/${userId}/update_status`;
